<template>
  <v-container>
    <v-layout
      row
      wrap
      justify-center
      mt-5
    >
      <v-flex
        xs5
        text-xs-center
        mt-5
      >
        <v-card
          hover
          flat
          class="afrus-card afrus-card-rounded afrus-card-border mt-5"
        >
          <v-card-text>
            <v-form
              @submit.prevent="doLogin"
            >
              <v-container>
                <v-layout
                  row
                  wrap
                  justify-center
                >
                  <v-flex
                    xs12
                    text-center
                    mb-3
                    pl-4
                    pr-4
                  >
                    <img
                      src="@/assets/afrus_logo_3.png"
                      alt="logo"
                      width="80px"
                    />
                  </v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  justify-center
                >
                  <v-flex
                    xs10
                  >
                    <div>
                      <h2 class="p-bold p-text text-center">
                        {{ $t('login.title') }}
                      </h2>
                      <br />
                      <p class="p-light span-text text-center">
                        {{ $t('login.subtitle') }}
                      </p>
                    </div>
                  </v-flex>
                </v-layout>
                <v-flex xs10 offset-xs1>
                  <v-text-field
                    v-model="email"
                    v-validate="'required|email'"
                    :label="$t('login.email')"
                    name="email"
                    required
                    data-vv-name="email"
                    :error-messages="errors.collect('email')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs10 offset-xs1>
                  <v-text-field
                    v-model="password"
                    v-validate="'required'"
                    :label="$t('login.password')"
                    type="password"
                    name="password"
                    required
                    data-vv-name="password"
                    :error-messages="errors.collect('password')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs10 offset-xs1 text-xs-center>
                  <v-btn
                    color="primary"
                    rounded
                    block
                    type="submit"
                  >
                    {{ $t('login.button') }}
                  </v-btn>
                </v-flex>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout
      row
      wrap
      justify-center
    >
      <v-flex xs5>
        <Footer/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import Footer from '@/components/Auth/Footer'

export default {
  name: 'Login',
  components: {
    Footer
  },
  data: () => ({
    email: '',
    password: ''
  }),
  methods: {
    ...mapActions({
      login: 'auth/login'
    }),
    async doLogin () {
      const isItRight = await this.$validator.validateAll()
      if (isItRight) {
        let data = {
          email: this.email,
          password: this.password
        }
        await this.login(data)
          .then(
            res => {
              if (res.data.token) {
                this.$auth.setToken(res.data.token.token)
                this.$router.push({ name: 'dashboard' })
              }
            },
            err => {
              console.log(err)
              this.$noty.error(`${this.$t('login.error')}`)
            }
          )
      }
    }
  }
}
</script>

<style>

</style>
